import type { ReactNode } from "react";

import type { HereAndNowTab } from "../tabs";
import { HaNContext } from "./HaNContext";

type HaNPageProps = {
  tab: HereAndNowTab;
  children?: ReactNode;
};

export const HaNPage = ({ tab, children }: HaNPageProps) => {
  return (
    <HaNContext.Provider value={{ tab }}>
      <div className="[grid-area:fullbody/fullbleed]">{children}</div>
    </HaNContext.Provider>
  );
};
